import { render, staticRenderFns } from "./Toefl.vue?vue&type=template&id=00e61284"
import script from "./Toefl.vue?vue&type=script&lang=js"
export * from "./Toefl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports